const FORMS_PATHS = {
  contact: {
    en: "/contact-us",
    es: "/es/contacto",
  },
  landing: {
    en: "/contact-uss",
    es: "/es/contactoo",
  },
};

export class FormEvents {
  constructor(formPaths = FORMS_PATHS) {
    this._formPaths = formPaths;
    this._handleClick = this._handleClick.bind(this);
  }

  _isValidPath(pathname) {
    return Object.values(this._formPaths).some((translations) =>
      Object.values(translations).some((path) => pathname.includes(path)),
    );
  }

  _handleClick(e) {
    const element = e.target.closest("a, button, btn, link");
    if (!element) return;

    const href = element.href;
    if (!href) return;

    let pathname;
    try {
      pathname = new URL(href).pathname;
    } catch {
      return;
    }

    if (this._isValidPath(pathname)) {
      sessionStorage.setItem("form_origin", window.location.href);
    }
  }

  static initAll(formPaths = FORMS_PATHS) {
    const instance = new FormEvents(formPaths);
    instance.init();
    return instance;
  }

  init() {
    document.addEventListener("click", this._handleClick);
  }

  destroy() {
    document.removeEventListener("click", this._handleClick);
  }
}

export default FormEvents;